import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs';
import { META_TAG } from 'src/app/core/const/meta_tag';
import { ConcessionService } from 'src/app/core/services/concession.service';
import { SeoTagsService } from 'src/app/core/services/seo-tags.service';

@Component({
  selector: 'app-concessionaire',
  templateUrl: './concessionaire.component.html',
  styleUrls: ['./concessionaire.component.scss'],
})
export class ConcessionaireComponent implements OnDestroy {
  concession: any;
  dep?: any;
  club: any;
  ami?: any;
  article: any = {
    titre: null,
    texte: null,
    image: null,
  };
  urlimg: any;
  personnel: any;
  limiteTexte: number = 500;
  isTexteCollapsed: boolean = false;
  departements: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private _router: Router,
    private _serviceConcession: ConcessionService,
    private _seoTags: SeoTagsService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.concession = params['concession'];
      this.dep = params['dep'];
      if (this.dep) {
        this.getInfoClub();
      } else {
        this.getInfoClubGen();
      }
    });
  }

  getInfoClubGen() {
    this._serviceConcession
      .getDetailConcessionGen(this.concession)
      .pipe(first())
      .subscribe(
        (response: any) => {
          if (response['data'].club) {
            this.club = response['data'].club;
            this.article = this.club.article;
            this.urlimg = this.article.image;
            this.personnel = response['data'].personnel;
            this.appliqueBalisesSeo(response['data']);
          }
        },
        (err) => {
          // window.open('https://thedoorman-recrute.fr/', '_self');
        }
      );
  }

  getInfoClub() {
    this._serviceConcession
      .getDetailConcession(this.concession, this.dep)
      .pipe(first())
      .subscribe(
        (response: any) => {
          if (response['data'].club) {
            this.club = response['data'].club;
            this.article = this.club.article;
            this.urlimg = this.article.image;
            this.personnel = response['data'].personnel;
            this.appliqueBalisesSeo(response['data']);
          }
        },
        (err) => {
          // window.open('https://thedoorman-recrute.fr/', '_self');
        }
      );
  }

  /**
   * Balises du <head> de la page d'agence : titre, description, partage social,
   * URL canonique et données structurées JSON-LD.
   *
   * Tout vient de la clé « seo » de l'API, calculée par le back
   * (App\Service\Seo\ClubSeo) — le même service qui alimente la page HTML rendue
   * aux robots d'IA. Une agence porte donc le même titre et la même adresse
   * qu'elle soit lue par un humain, par Googlebot (qui exécute ce JavaScript) ou
   * par ClaudeBot (qui reçoit la version Symfony).
   *
   * Ce que ça corrige : le titre était META_TAG.concept.title, une constante —
   * les quelques dizaines de pages d'agences annonçaient toutes le même titre à
   * Google, et aucune ne déclarait d'URL canonique.
   *
   * Le repli est volontaire : le front et le back se déploient séparément, la clé
   * « seo » peut donc manquer le temps d'une mise en production.
   */
  private appliqueBalisesSeo(data: any) {
    this._seoTags.apply(data?.seo, {
      title: META_TAG.concept.title,
      description: data?.seodata?.description,
    });
  }

  ngOnDestroy() {
    // Sans ça, le JSON-LD et le canonical de cette agence resteraient dans le
    // document pendant la navigation vers la page suivante.
    this._seoTags.clear();
  }

  onNavigateRejoindre() {
    window.open('https://thedoorman-recrute.fr/', '_blank', 'noopener,noreferrer');
  }
}
